"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTabId = exports.getPanelId = void 0;

var removeSpaces = function removeSpaces(value) {
  if (typeof value === 'string') {
    return value.replace(/\s/g, '');
  }

  return value;
};

var getTabId = function getTabId(tabGroup, value) {
  return "StencilTabPanel-".concat(removeSpaces(tabGroup), "-").concat(removeSpaces(value));
};

exports.getTabId = getTabId;

var getPanelId = function getPanelId(tabId) {
  return "".concat(tabId, "-panel");
};

exports.getPanelId = getPanelId;